import React from "react";
import clsx from "clsx";
import { Card, Grid, Typography, withStyles } from "@material-ui/core";

interface IProps {
  classes: any;
  label: string;
  value: string;
  isBold?: boolean;
}

/** Componente Cartão que exibe os valores da composição/insumo selecionado. */
export const CardTotal = withStyles({
  container: {
    maxWidth: "8.375rem",
    minWidth: "fit-content",
  },
  card: {
    padding: "0.25rem 1rem 0.25rem 0.5rem",
    margin: 0,

    "& .title": {
      color: "#757575",
      fontWeight: 400,
    },
    "&.bold .title": {
      color: "#212121",
      fontWeight: 600,
    },
    "& .text-value": {
      color: "#757575",
      fontWeight: 700,
      fontSize: "1.25rem",
      lineHeight: "1.1",
    },
    "&.bold .text-value": {
      color: "#212121",
    },
  },
})(({ classes, label, value, isBold = false }: IProps) => {
  return (
    <Grid item xs={2} className={classes.container}>
      <Card className={clsx(classes.card, { bold: isBold })}>
        <Typography className="title">{label}</Typography>
        <Typography className="text-value">{value}</Typography>
      </Card>
    </Grid>
  );
});



// WEBPACK FOOTER //
// ./src/modules/WBS/components/layouts/DialogItemOccurrences/CardTotal.tsx